/* eslint-disable react/prop-types */
import React, { Fragment, useState, useEffect } from 'react'
import {
  makeStyles,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
  Dialog,
  // DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core'
import Cookies from 'js-cookie'

import { Alert, Pagination } from '@material-ui/lab'
import { ReactComponent as SearchIcon } from '@assets/images/svg/search.svg'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { resellerApiWithToken } from '@api/baseApi'
import SalesOrderDialog from '../../../OrderManagement/SalesOrderDialog'
// import { getCollectionApi, getApi } from './api'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1.5rem 2rem',
    background: '#fff',
    borderRadius: 10,
    marginBottom: '2rem',
    '& p': {
      fontWeight: 600,
      lineHeight: '27px',
    },
  },
  table: {
    marginTop: '0.625rem',
    paddingBottom: '2rem',
  },
  percentage: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  searchField: {
    '& .MuiInputBase-root': {
      padding: '0.375rem 0.75rem',
      border: '1px solid #C4C4C4',
      borderRadius: 5,
    },
    '& .MuiInputAdornment-positionStart': {
      paddingBottom: 0,
    },
    '& .MuiInputBase-input': {
      height: 'auto',
      padding: 0,
    },
  },
  dateField: {
    '& .MuiInputBase-root': {
      padding: '0.375rem 0.75rem',
      border: '1px solid #C4C4C4',
      borderRadius: 5,
      width: 170,
      marginRight: '1rem',
    },
    '& .MuiInputBase-input': {
      height: 'auto',
      padding: 0,
    },
  },
  filterForm: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '1rem',
  },
  loading: {
    padding: '1rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  resetButton: {
    fontSize: '0.875rem',
    height: 38,
  },
}))

const TableOrders = () => {
  const classes = useStyles()
  const [loading, setLoading] = useState(true)
  const [orders, setOrders] = useState()
  const [openOrder, setOpenOrder] = useState(false)
  const [dataOrder, setDataOrder] = useState()
  const [params, setParams] = useState({
    page: 1,
    per_page: 10,
  })
  const scope = Cookies.get('scope')

  let path

  if (scope === 'reseller') {
    path = '/resellers/orders'
  } else {
    path = '/affiliates/orders'
  }

  const fetchorder = async () => {
    try {
      setLoading(true)
      const { status, data } = await resellerApiWithToken.get(path, { params })

      if (status === 200) {
        setOrders(data)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
    }
  }

  const resetFilter = () => {
    setParams({
      page: 1,
      per_page: 10,
    })
  }

  useEffect(() => {
    fetchorder()
  }, [params])

  const showOrder = async (id) => {
    if (id) {
      const { status, data } = await resellerApiWithToken.get(`${path}/${id}`)
      if (status === 200) {
        setOpenOrder(true)
        setDataOrder(data?.data)
      }
    }
  }

  return (
    <div className={classes.root}>
      <p>Penjualan</p>
      <div className={classes.filterForm}>
        <TextField
          placeholder="Cari Nomor"
          value={params.transaction_id_customer_name || ''}
          onChange={(e) => setParams({ ...params, transaction_id_customer_name: e.target.value })}
          className={classes.searchField}
          InputProps={{
            startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
          }}
          variant="outlined"
        />
        <div>
          <Button
            color="primary"
            variant="contained"
            className={classes.resetButton}
            onClick={() => resetFilter()}
          >
            Reset
          </Button>
          {/* </MuiPickersUtilsProvider> */}
        </div>
      </div>
      {!loading ? (
        <Fragment>
          {orders && orders.data?.length > 0 ? (
            <Fragment>
              <TableContainer className={classes.table}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>ID Transaksi</TableCell>
                      <TableCell>Customer</TableCell>
                      <TableCell>Komisi</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Total</TableCell>
                      <TableCell>Aksi</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orders.data.map((order, index) => (
                      <TableRow key={order.id}>
                        <TableCell>{(((params.page - 1) * 10) + (index + 1))}</TableCell>
                        <TableCell>{order.transaction_id}</TableCell>
                        <TableCell>{order.customer_name}</TableCell>
                        <TableCell>{order.status !== 'pending' ? order.formatted_comission || order.formatted_commission : ''}</TableCell>
                        <TableCell>{order.status}</TableCell>
                        <TableCell>{order.formatted_subtotal}</TableCell>
                        <TableCell>
                          <Tooltip title="Lihat Detail" placement="bottom">
                            <IconButton
                              onClick={() => showOrder(order.id)}
                              className={classes.button}
                              color="primary"
                            >
                              <VisibilityIcon color="secondary" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Pagination
                count={orders.pagination.total_pages}
                page={params.page}
                onChange={(_event, value) => setParams({ ...params, page: value })}
                shape="rounded"
              />
            </Fragment>
          ) : (
            <Alert variant="outlined" severity="warning">
              Data yang di cari masih kosong / tidak ditemukan
            </Alert>
          )}
        </Fragment>
      ) : (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      )}

      <Dialog
        open={openOrder}
        onClose={() => setOpenOrder(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent>
          <SalesOrderDialog data={dataOrder} />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpenOrder(false)}
          >
            Tutup
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default TableOrders
